import { Controller } from "@hotwired/stimulus"

// Animates a number from 0 to its final value on connect
export default class extends Controller {
  static values = { target: Number, duration: { type: Number, default: 800 }, suffix: { type: String, default: "" } }

  connect() {
    const end = this.targetValue
    if (!end && end !== 0) return

    const duration = this.durationValue
    const suffix = this.suffixValue
    const start = 0
    const startTime = performance.now()
    const isInteger = Number.isInteger(end)

    const animate = (now) => {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3)
      const current = start + (end - start) * eased

      this.element.textContent = (isInteger ? Math.round(current) : current.toFixed(2)) + suffix

      if (progress < 1) requestAnimationFrame(animate)
    }

    this.element.textContent = "0" + suffix
    requestAnimationFrame(animate)
  }
}
